// extracted by mini-css-extract-plugin
export default {"container":"teams_container__z6Vs4","slide-in-bottom":"teams_slide-in-bottom__DYrCY"};